module.exports = __webpack_public_path__ + "static/media/ios-reorder.2ed71bff.svg";